export const uploadFileType: any = {
  preview: "preview",
  audio: "audio",
  ebook: "ebook",
  img: "img",
};
